import React from 'react';
import { DisabledIcon } from './DisabledIcon/DisabledIcon';
import classes from './EmptyResultsSetPlaceholder.module.scss';

export default function EmptyResultsSetPlaceholder({ text, icon }: { text?: string; icon?: JSX.Element }) {
    return (
        <div className={classes.emptyState}>
            <div className={classes.emptyResultsSet}>
                {icon && (
                    <span className={classes.iconContainer}>
                        <DisabledIcon iconComponent={icon} />
                    </span>
                )}
                {text && <span>{text}</span>}
            </div>
        </div>
    );
}
